import api from '@/api'
import helpers from './helper-functions.js'
import $ from 'jquery'

var apiMixins = {
  data () {
    return {
      loading: false,
      posts: [],
      model: {},
      userIsLoggedIn: false,
      xlsxInput: {},
      showPreview: false,
      previewDataSets: {},
      // previewData: [],
      dataSetName: '1',
      englishToGerman: helpers.englishToGerman(),
      previewColumnSets: {},
      query: { limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      total: 0,
      warnings: [],
      selection: []
    }
  },
  async created () {
    await this.refreshActiveUser()
    await this.getQuery()
    // await this.refreshPosts()
  },
  computed: {
    route () {
      return this.$route
    },
    previewData () {
      return this.previewDataSets[this.dataSetName]
    },
    previewColumns () {
      return this.previewColumnSets[this.dataSetName]
    },
    sheetOptions () {
      var options
      if (this.experimentName === 'proliferation') {
        options = ['data-transfer']
      } else if (this.experimentName === 'patient') {
        options = this.sheetNames
      } else if (['compound', 'ha', 'gf'].includes(this.experimentName)) {
        options = ['compounds', 'HA', 'GF']
      } else {
        options = [1] // returns the first sheet in the file
      }
      this.dataSetName = options[0]
      return options
    },
    nChanges () {
      return this.query.nChanges
    }
  },
  methods: {
    refreshPosts () {
      // I'm only here to suppress a warning
    },
    async getQuery () {
      var postResource = helpers.getPostResource(this.$route).replace('exudats/', '')
      var query = await api.getQueryCookie(postResource)
      if (!$.isEmptyObject(query)) this.query = query
      else this.refreshPosts()
    },
    async refreshActiveUser () {
      this.loading = true
      var userInfo = await api.getUser()
      this.userIsLoggedIn = !!userInfo
      this.loading = false
    },
    async populatePostToEdit (post) {
      this.meds = post.patient_med
      this.coms = post.patient_com
      this.model = Object.assign({}, post)
    },
    async deletePost (id) {
      if (confirm('Are you sure you want to delete this post?')) {
        // if we are editing a post we deleted, remove it from the form
        if (this.model.id === id) {
          this.model = {}
        }
        await api.deletePost(this.dataConfig.databaseName, id)
        this.refreshPosts(this.dataConfig.databaseName)
      }
    },
    createDataPreview (previewSets) {
      this.sheetNames = Object.keys(previewSets)
      var prevDataSets = {}
      var englishToGerman = this.englishToGerman
      Object.keys(previewSets).forEach(key => {
        var dataSet = previewSets[key]
        var previewData = JSON.parse(JSON.stringify(dataSet))
        // Create columns for preview table
        var providedCols = Object.keys(Object.assign({}, ...previewData)) // get keys of all rows
        var usedHeaders = (this.route.params.experiment && ['compound', 'ha', 'gf'].includes(this.route.params.experiment)) ? helpers.compoundHeaders : this.dataConfig.tableHeader
        var testCols = usedHeaders.filter(head => {
          return providedCols.includes(head.db_key)
        })
        this.previewColumnSets[key] = testCols.map(col => {
          return {
            field: col.db_key,
            title: englishToGerman[col.db_key],
            category: col.category
          }
        })
        this.showPreview = true

        // Create Data for preview table
        previewData = previewData.map(patient => {
          var patientKeys = Object.keys(patient)
          var patObj = patient
          patientKeys.forEach(patKey => {
            if (Array.isArray(patient[patKey])) {
              patObj[patKey] = patient[patKey].join(', ')
            }
          })
          return patObj
        })
        prevDataSets[key] = previewData
      })
      this.previewDataSets = prevDataSets
    },
    deleteDataPreview () {
      this.showPreview = false
      this.newPatients = []
      this.previewDataSets = {}
      this.previewColumnSets = {}
      this.warnings = []
      this.$router.go()
    },
    async submitFile (resource, isExperiment) {
      this.loading = true
      var response, currExp, resourceName
      var xlsxInput = this.xlsxInput
      if (isExperiment) {
        await Promise.all(
          Object.keys(xlsxInput).map(async function (key) {
            currExp = xlsxInput[key]
            resourceName = key.replace('compounds', 'compound').replace('data-transfer', 'proliferation').replace('1', 'we')
            response = await api.createPosts(resourceName, currExp, true)
            helpers.createUploadFeedback(response)
            return response
          })
        )
      } else {
        response = await api.createPosts(resource, xlsxInput[1])
        helpers.createUploadFeedback(response)
      }
      this.$router.go()
    },
    async refreshQuery () {
      var postResource = helpers.getPostResource(this.$route).replace('exudats/', '')
      await api.setQueryCookie({ query: this.query, postResource })
      this.dataConfig && this.refreshPosts(this.dataConfig.databaseName)
    }
  },
  watch: {
    /* query: {
      async handler () {
        // this.refreshQuery()
      },
      deep: false
    }, */
    nChanges: {
      async handler () {
        await this.refreshQuery()
      },
      deep: false
    },
    route: {
      async handler () {
        this.refreshActiveUser()
        await this.getQuery()
        this.query.offset = 0
      },
      deep: true
    }
    /* previewDataSets: {
      handler () {
        console.log('New Preview')
        this.previewData = this.previewDataSets[this.dataSetName]
      }
    } */
  }
}

export default apiMixins



// WEBPACK FOOTER //
// ./src/mixins/table_mixins.js